import { FieldObjectType } from 'module/api/field/types';
import { SourceType } from 'module/api/filter/types';
import { getRandomColor } from 'module/helpers/get-random-color';
import { useTranslate } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import {
  FilterableField,
  SingleSelectField,
} from 'module/types/filter-field/field/filterable-field';
import { useCustomerRolesQuery } from 'queries/roles';
import { useMemo } from 'react';

const FIELD_ID_ROLE = -1;

export const useExternalTeamMemberNativeFieldsAsFilterableFields = () => {
  const translate = useTranslate();

  const { data: roles, isLoading: _isRoleLoading } = useCustomerRolesQuery();
  const roleOptions = useMemo(
    () =>
      (roles ?? []).map(({ roleId, roleName }) => ({
        label: roleName,
        value: roleId,
        color: getRandomColor(roleId),
        active: true,
      })),
    [roles],
  );
  const _roleField: SingleSelectField = useMemo(
    () => ({
      fieldId: FIELD_ID_ROLE,
      fieldName: 'role',
      fieldLabel: translate('role'),
      type: FieldType.SingleSelect,
      private: false,
      userCreated: false,
      metaData: {
        options: roleOptions,
      },
      sourceType: SourceType.User,
      objectType: FieldObjectType.Users,
    }),
    [translate, roleOptions],
  );

  const fields = useMemo(
    () =>
      [].map(
        (x: any) =>
          ({
            ...x,
            customField: false,
            private: false,
            sourceType: SourceType.User,
            objectType: FieldObjectType.Users,
          }) as FilterableField,
      ),
    [],
  );

  return useMemo(
    () => ({
      fields: [...fields],
      loading: false,
    }),
    [fields],
  );
};
